<template>
  <div>
    <pl-dialog
      size="lg"
      :title="'Edit Genie Recap Summary'"
      class="font-semibold text-gray-700 text-base"
      @close="$emit('close')"
      :disableOutsideClick="true"
    >
      <body class="mx-7 flex flex-col overflow-y-auto overflow-x-hidden h-full">
        <div class="flex flex-col h-full my-5">
          <div class="h-full rounded-md border border-solid border-gray-200">
            <Editor
              v-if="isRenderEditor"
              api-key="no-api-key"
              v-model="recap_summary"
              :init="editorOptions"
            />
          </div>
        </div>
      </body>
      <footer class="mx-7 mb-5">
        <div class="flex justify-between w-full text-sm">
          <button
            class="px-4 py-2 mr-2 bg-white border border-solid border-gray-200 hover:shadow-sm rounded cursor-pointer text-gray-600"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            :disabled="loading"
            @click="saveGenieRecapSummary"
            class="sample px-5 py-2 bg-primary rounded cursor-pointer text-white font-medium disabled:opacity-50"
          >
            Save Changes
          </button>
        </div>
      </footer>
    </pl-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import Editor from '@tinymce/tinymce-vue';

  export default {
    components: {
      Editor,
    },
    data() {
      return {
        recap_summary: '',
        isRenderEditor: false,
        loading: false,
        editorOptions: {
          selector: '#text-editor-written',
          menubar: false,
          branding: false,
          statusbar: this.statusBar,
          resize: false,
          elementpath: false,
          placeholder: 'Write your response here',
          toolbar_items_size: 'small',
          browser_spellcheck: true,
          content_css: '/static/tinymce/tinymce.css',
          emoticons_append: {
            custom_mind_explode: {
              keywords: ['brain', 'mind', 'explode', 'blown'],
              char: '🤯',
            },
          },
          plugins: [
            'link, media, autolink, advlist, lists, lists code emoticons,fullscreen, table, wordcount, nonbreaking',
          ],
          nonbreaking_force_tab: true,
          noneditable_noneditable_class: 'mceNonEditable',
          block_formats: 'Body=p;Header 1=h2;Header 2=h3;',
          toolbar:
            'fullscreen | undo redo | bold underline | alignleft aligncenter | removeformat | numlist bullist | formatselect | emoticons link imageupload fileupload media | table | templates',
          skin_url: '/static/tinymce/tiny5skin/skins/ui/tiny5skin',
          media_alt_source: false,
          media_poster: false,
          media_dimensions: false,
          link_title: false,
          default_link_target: '_blank',
          target_list: false,
          contextmenu: false,
          setup: this.setInitialConfigs,
          toolbar_drawer: false,
          toolbar_mode: 'sliding',
        },
      };
    },
    props: {
      genieRecap: {
        type: Object,
        default: {},
      },
    },
    computed: {
      ...mapGetters([
        'getCurrentRT',
        'getProfile',
        'hasTeacherPermissionsInCourse',
      ]),
    },
    methods: {
      saveGenieRecapSummary() {
        this.loading = true;
        const payload = {
          roundtable_id: this.getCurrentRT.id,
          prompt_summary: this.recap_summary,
        };
        this.$store
          .dispatch('updateGenieRecap', { id: this.genieRecap.id, payload })
          .then(() => {
            this.$emit('close');
            const toast = {
              type: 'Success',
              message: 'Genie Recap summary successfully updated.',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          })
          .catch((err) => {
            console.error(err);
            const toast = {
              type: 'error',
              message:
                'Sorry! Something wrong happenned on updating Genie Recap summary! Try again!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          })
          .finally(() => (this.loading = false));
      },
    },
    mounted() {
      this.recap_summary = this.genieRecap.prompt_summary;
      this.isRenderEditor = true;
    },
  };
</script>



// WEBPACK FOOTER //
// editGenieRecapModal.vue?1e172847